import React from 'react';
import styled from 'styled-components';

const Wrap = styled.a`
	color: inherit;
	text-decoration: none;
	cursor: pointer;
`;

export default props => <Wrap {...props}>{props.children}</Wrap>;
